import React from "react";
import RogarStudio from "../../assets/contacts/RogerStudio.png";
import {
  Instagram,
  Twitter,
  Facebook,
  Youtube,
  Tiktok,
} from "../../assets/SvgIcons";

import { useNavigate } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="footer-section">
      <div className="footer-section-main">
        <img src={RogarStudio} alt="" className="w-100 " />
        <FooterBorder />
        <div className="w-100 d-flex  justify-content-between footer-wrapper">
          <div className="d-flex justify-content-between  flex-column">
            <ul className=" footer-list">
              <li>
                <Nav.Link href="#services">{t("Services")}</Nav.Link>
              </li>
              <li>
                <Nav.Link href="#aboutStudio">{t("About studio")}</Nav.Link>
              </li>
              <li>
                <Nav.Link href="#Team">{t("Team")}</Nav.Link>
              </li>
              <li>
                <Nav.Link href="#Equipment">{t("Equipment")}</Nav.Link>
              </li>
              <li>
                <Nav.Link href="#Portfolio">{t("Portfolio")}</Nav.Link>
              </li>
              <li>
                <Nav.Link href="#Contacts">{t("Contacts")}</Nav.Link>
              </li>
            </ul>

            <ul className=" footer-list fooet-second-list">
              <li>©2022. All rights reserved. Roger Studio</li>
              <li onClick={() => navigate("/privacy")}>
                {t("Privacy policy")}
              </li>
            </ul>
          </div>

          <div className="footer-bootom-right">
            <h2>+38 063 258 54 24</h2>
            <p>{t("Kurinna 24, Dnipro Ukraine")}</p>

            <div className=" d-flex justify-content-end footer-icons gap-3 py-2">
            <a href="https://www.instagram.com/rogersounds/" target="_blank" rel="noreferrer">
              <Instagram />
              </a>
              <a href="https://x.com/rogersounds" target="_blank" rel="noreferrer">
              <Twitter />
              </a>
              <a href="https://www.facebook.com/rogersoundsfb" target="_blank" rel="noreferrer">
              <Facebook />
              </a>
              <a href="https://www.youtube.com/@rogersounds" target="_blank" rel="noreferrer">
              <Youtube />
              </a>
              <a href="https://www.tiktok.com/@rogersoundstt" target="_blank" rel="noreferrer">
              <Tiktok />
              </a>
            </div>
          </div>

          <ul className=" footer-list footer-third-list">
            <li onClick={() => navigate("/privacy")}>
            {t("Privacy policy")}
            </li>
            <li>©2022. All rights reserved. Roger Studio</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;

export const FooterBorder = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="1"
      viewBox="0 0 1140 1"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-0.000389954 1L0.000488281 0L1140 0L1140 1L-0.000389954 1Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
};
